
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue';

import useRoles from '@/modules/administracion/composables/useRoles';

export default {
    components: {
        RolEditarComponent: defineAsyncComponent(
            () => import('@/modules/administracion/components/RolEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerRoles,
            cambiarEstadoRol,
        } = useRoles();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Nombre', value: 'nombre', sortable: true },
            { text: 'Descripción', value: 'descripcion', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let roles: any = [];
        const rolesFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const rolEditarComponentRef = ref();

        onMounted(async () => {
            await buscarRoles();
        });

        const buscarRoles = async () => {
            const resp = await obtenerRoles(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                roles = resp.data;
                rolesFiltrados.value = JSON.parse(JSON.stringify(roles));
            }
        }

        const nuevoRol = async () => {
            rolEditarComponentRef.value.abrirComponent();
        }

        const editarRol = async (rol: any) => {
            rolEditarComponentRef.value.abrirComponent(rol.id_rol);
        }

        const alternarEstadoRol = async (rol: any) => {
            const resp = await cambiarEstadoRol(rol.id_rol, !rol.estado);
            if (resp.ok) {
                await buscarRoles();
            }
        }

        const filtrarInformacion = async () => {
            rolesFiltrados.value = JSON.parse(JSON.stringify(
                roles.filter(
                    (r: any) => r.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarRolComponentEmit = async (seGrabo: boolean) => {
            if (seGrabo) {
                await buscarRoles();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            rolesFiltrados,

            buscarRoles,
            editarRol,
            alternarEstadoRol,
            filtrarInformacion,
            nuevoRol,

            rolEditarComponentRef,
            cerrarEditarRolComponentEmit,
        };
    }
}
